<template>
  <div>
    UPLOAD DOCUMENT
    <hr>
    <b-form-group :class="{'error-input' : $v.data_upload_document.title.$error}">
      <label> Upload Document Title </label>
      <j-input
        v-model="$v.data_upload_document.title.$model"
        :max-length="255"
        placeholder="Upload Document Title"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeUpdateDocument">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveUploadDocument">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_upload_document: {
      title: {
        required,
      },
    },
  },
  data() {
    return {
      data_upload_document: {
        title: '',
      },
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['list_channel']),

    generateDataUploadDocument() {
      const infoName = this.data_upload_document.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_upload_document.title,
        widget_master_id: this.dataMaster.id,

        type: 3,
        position: this.dataMaster.position,
      };
      return data;
    },

    generateDataUploadDocumentUpdate() {
      const infoName = this.data_upload_document.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_upload_document.title,
        widget_master_id: this.dataMaster.id,

        type: 3,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_upload_document.title = JSON.parse(this.dataEdit.info).name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget']),

    saveUploadDocument() {
      this.$v.data_upload_document.$touch();
      if (!this.$v.data_upload_document.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateDataUploadDocument;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataUploadDocumentUpdate;
          this.updateWidget({ widgetId, dataParam });
        }
        this.closeUpdateDocument();
      }
    },

    closeUpdateDocument() {
      this.$emit('close-field');
      this.data_upload_document.title = null;
      setTimeout(() => {
        this.$v.data_upload_document.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jUploadDocumentSetup.vue